import React from "react";

function toMMSS(seconds) {
  if (seconds === null || seconds === undefined) {
    return "--:--";
  }

  const safe = Math.max(0, Number(seconds));
  const mins = Math.floor(safe / 60)
    .toString()
    .padStart(2, "0");
  const secs = Math.floor(safe % 60)
    .toString()
    .padStart(2, "0");
  return `${mins}:${secs}`;
}

export default function WaitingOverlay({
  waitingRemainingSeconds,
  showWaitingActions,
  waitingCycle,
  onEndInterview,
  onWaitMore,
  uiState,
}) {
  const isWaiting = uiState === "WAITING";
  const title = isWaiting ? "Interview Waiting" : "Interview Reconnecting";
  const description = isWaiting
    ? "The other participant left. We will keep this interview open while they rejoin."
    : "Your connection is recovering. Please stay on this screen while we reconnect the interview.";

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: "rgba(5, 20, 30, 0.72)",
        backdropFilter: "blur(3px)",
        color: "#f6f8fb",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 15,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          width: "min(500px, 92vw)",
          borderRadius: 16,
          border: "1px solid rgba(255,255,255,0.22)",
          background: "linear-gradient(170deg, #17354f, #0f2437)",
          padding: 20,
          pointerEvents: "auto",
        }}
      >
        <h2 style={{ marginTop: 0, marginBottom: 8 }}>{title}</h2>
        <p style={{ opacity: 0.88, margin: 0 }}>
          {description}
        </p>

        {isWaiting ? (
          <>
            <div style={{ marginTop: 16, fontSize: 26, fontWeight: 700 }}>
              {toMMSS(waitingRemainingSeconds)}
            </div>
            <div style={{ marginTop: 4, fontSize: 12, opacity: 0.75 }}>
              Waiting cycle #{waitingCycle || 0}
            </div>
          </>
        ) : (
          <div style={{ marginTop: 16, fontSize: 15, opacity: 0.82 }}>
            Reconnecting to the interview room...
          </div>
        )}

        {isWaiting && showWaitingActions ? (
          <div style={{ marginTop: 18, display: "flex", gap: 10 }}>
            <button
              type="button"
              onClick={onEndInterview}
              style={{
                border: "none",
                borderRadius: 8,
                padding: "10px 14px",
                background: "#d93c3c",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              End Interview
            </button>
            <button
              type="button"
              onClick={onWaitMore}
              style={{
                border: "none",
                borderRadius: 8,
                padding: "10px 14px",
                background: "#219c61",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              Wait 10 More Minutes
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
}
